export function parseQueryString(url) {
	url = !url ? location.href : url;
	if (url.indexOf('?') === -1) {
		return {};
	}
	var search = url[0] === '?' ? url.substr(1) : url.substring(url.lastIndexOf('?') + 1);
	if (search === '') {
		return {};
	}
	search = search.split('&');
	var query = {};
	for (var i = 0; i < search.length; i++) {
		var pair = search[i].split('=');
		query[decodeURIComponent(pair[0])] = decodeURIComponent(pair[1] || '');
	}
	return query;
}
// report
export function bytesToSize(bytes) {
	var sizes = [ 'Bytes', 'KB', 'MB', 'GB', 'TB' ];
	if (bytes == 0) return '0 Byte';
	var i = parseInt(Math.floor(Math.log(bytes) / Math.log(1024)));
	return Math.round(bytes / Math.pow(1024, i), 2) + ' ' + sizes[i];
}
